import Character from '../classes/character'
export default [
    new Character("Wendy Adams", 0),
    new Character("Leo Anderson", 2),
    new Character("Agnes Baker", null),
    new Character("Roland Banks", null),
    new Character("Jenny Barnes", null),
    new Character("Jim Culver", 1),
    new Character("Joe Diamond", 1),
    new Character("Ursula Downs", 1),
    new Character("Dexter Drake", 2),
    new Character("Finn Edwards", null),
    new Character("Preston Fairmont", 0),
    new Character("Preston Fairmont (2 resources available)", 0, true),
    new Character("Carolyn Fern", 1),
    new Character("Mark Harrigan", null),
    new Character("Patrice Hathaway", 1),
    new Character("Lola Hayes", 2),
    new Character("Marie Lambeau", 1),
    new Character("Silas Marsh", 0),
    new Character("Sister Mary", 1),
    new Character("Father Mateo", 0, true),
    new Character("Father Mateo (ability unavailable)", 0, true),
    new Character("Tony Morgan", 2),
    new Character("Tommy Muldoon", 2),
    new Character("Rex Murphy", 2),
    new Character("Akachi Onyele", 1),
    new Character('"Skids" O\' Toole', 2),
    new Character('"Aschan" Pete', 2),
    new Character("Minh Thi Phan", 1),
    new Character("Luke Robinson", 1),
    new Character("Sefina Rousseau", 3),
    new Character("Zoey Samaras", 1),
    new Character("Trish Scarborough", 2),
    new Character("Amanda Sharpe", 0),
    new Character("Diana Stanley", 2),
    new Character("Mandy Thompson", 0),
    new Character("Daisy Walker", 0),
    new Character("Norman Withers", null),
    new Character("Calvin Wright", 0),
    new Character("William Yorick", 2),
    new Character("Rita Young", 2)
]